export default __webpack_public_path__ + "static/media/139.cd969277.jpg";